import { gql } from '@apollo/client';

export default class EmployeeMutation {
    static UPDATE_EMPLOYEE_LOGIN_PERMISSION = gql`
        mutation updateEmployeeLoginPermission(
            $userId: Int!
            $input: EmployeeLoginPermissionInput!
        ) {
            updateEmployeeLoginPermission(userId: $userId, input: $input)
        }
    `;
}
